import { Id_building, Id_drawing, Id_floor } from "./api/Identifiers";
import { Drawing } from "./drawings/Drawing";
import { Cookie } from "./Cookies";
import { State } from "./redux/State";
import { exists } from "./utils";
import { Building, BuildingCollection } from "./Building";

// The drawing_history is a stack - the most recently loaded drawing is at index 0

const DRAWING_HISTORY_COOKIE_NAME: string = "drawings_history";

function get_the_first_historical_drawing_that_matches(drawings: Drawing[], state: State): Drawing | null{
    // step 1 - convert the drawings array to an array of id_drawing strings for searching
    // step 2 - walk the drawing history
    // step 3 - the first drawing in the DH that is in the building is the drawing to return
    // if step 3 found nothing, 



    let drawing_ids: string[] = drawings.map((val: Drawing) => {
        return val.id.value;
    })
    let drawings_history: string[] = get_drawings_history();
    for (let i = 0; i < drawings_history.length; i++) {
        if (drawing_ids.includes(drawings_history[i])) {
            return state.all_displayable_drawings.get_drawing_from_drawing_id(Id_drawing.wrap(drawings_history[i]));
        }
    }
    // no drawing found in the history. 
    console.info(`could not find a drawing in the history that exists in the current state.`)
   
    return null;  // nothing found
}

// returns a defualt drawing: First Building, First floor in that building
export function get_default_drawing(state: State): Drawing | null{
    let drawing : Drawing = null;
    let building : Building = null;
    for (let i = 0; i < state.buildings.length; i++){
        building = state.buildings.as_array[i];
        if (exists(building)){
            drawing = state.all_displayable_drawings.get_a_drawing_for_the_first_floor_in_building(building.id_building);
            if (exists(drawing)){
                console.debug(`here found a drawing in the current state.`)
                break;
            }
        }
    }
    if (!exists(drawing)){
        console.debug(`BAD could not find a drawing in the current state. at. all.`)
    }
    
    return drawing;
}

export function get_a_drawing_from_building(id_building: Id_building, state: State): Drawing | null {
    let drawings: Drawing[] = state.all_displayable_drawings.get_all_in_building(id_building).drawings;
    let drawing : Drawing = get_the_first_historical_drawing_that_matches(drawings, state);
    if (!exists(drawing)){
        drawing = state.all_displayable_drawings.get_a_drawing_for_the_first_floor_in_building(id_building);
    }
    return drawing;
}

export function get_a_drawing_from_floor(id_floor: Id_floor, state: State): Drawing | null {
    let d: Drawing[] = state.all_displayable_drawings.get_all_in_floor(id_floor).drawings;
    let drawing: Drawing = get_the_first_historical_drawing_that_matches(d, state);
    if (!exists(drawing)){
        if (d.length > 0){
            drawing = d[0];
        }
    }
    return drawing;
}

function get_drawings_history(): string[] {
    return Cookie.read_json_array(DRAWING_HISTORY_COOKIE_NAME);
}

export function get_a_drawing(state: State): Drawing | null {
    let drawings: Drawing[] = state.all_displayable_drawings.drawings;
    let drawing : Drawing = get_the_first_historical_drawing_that_matches(drawings, state);

    return drawing;
}

export function update_the_drawing_history(id_drawing: Id_drawing) {
    let old_drawings_history: string[] = get_drawings_history();
    // remove the deleted drawing if it exists
    let updated_drawings_history: string[] = old_drawings_history.filter((val: string) => {
        return val != id_drawing.toString();
    })

    updated_drawings_history.unshift(id_drawing.toString())  // unshift is "prepend"
    Cookie.write_json(DRAWING_HISTORY_COOKIE_NAME, updated_drawings_history);
}


// WEBPACK FOOTER //
// ./src/ts/DrawingHistory.ts